module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_2_CIUDADANO.7b38511a.jpg";